var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-layout',[_c('common-page-plain',[_c('common-content-spacer',{attrs:{"height":"medium","isCenter":true}},[_c('invites-member-form',{attrs:{"inviteBy":_vm.inviteBy}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }